
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.Date_$external_fun' : () => new Date(),
        'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
        'kotlin.uuid.get' : (array, index) => array[index],
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
        'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
        'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
        'org.khronos.webgl.ArrayBuffer_$external_class_get' : () => ArrayBuffer,
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
        'org.w3c.dom.Worker_$external_class_get' : () => Worker,
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
        'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
        'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
        'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
        'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
        'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
        'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
        'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
        'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
        'kotlinx.io.node.persistModule' : 
            (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
                await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
        ,
        'kotlinx.io.node.getRequire' : () => { 
            const importMeta = import.meta;
            return globalThis.module.default.createRequire(importMeta.url);
        }
        ,
        'kotlinx.io.node.requireModule' : 
            (require, mod) => {
                 try {
                     let m = require(mod);
                     if (m) return m;
                     return null;
                 } catch (e) {
                     return null;
                 }
            }
        ,
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
        'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
        'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.github.alexzhirkevich.compottie.internal.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
        'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter' : (_this) => _this.id,
        'io.github.alexzhirkevich.compottie.internal.kind_$external_prop_getter' : (_this) => _this.kind,
        'io.github.alexzhirkevich.compottie.internal.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter_1' : (_this) => _this.id,
        'io.github.alexzhirkevich.compottie.internal.message_$external_prop_getter' : (_this) => _this.message,
        'io.github.alexzhirkevich.compottie.internal.platform.DecodeImageRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
        'io.github.alexzhirkevich.compottie.internal.platform.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'com.teachmint.sharex.filetransfer.jsPickFile' : 
            () => {
                return new Promise((resolve) => {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.style.display = 'none';
                    input.addEventListener('change', () => {
                        const file = input.files && input.files[0];
                        if (!file) { resolve(null); input.remove(); return; }
                        const reader = new FileReader();
                        reader.onload = () => {
                            const arrayBuffer = reader.result;
                            const uint8 = new Uint8Array(arrayBuffer);
                            const result = {
                                name: file.name,
                                size: file.size,
                                type: file.type || '',
                                bytes: uint8
                            };
                            resolve(result);
                            input.remove();
                        };
                        reader.onerror = () => { resolve(null); input.remove(); };
                        reader.readAsArrayBuffer(file);
                    });
                    input.addEventListener('cancel', () => { resolve(null); input.remove(); });
                    document.body.appendChild(input);
                    input.click();
                });
            }
            ,
        'com.teachmint.sharex.filetransfer.jsFileResultName' : (result) => result.name,
        'com.teachmint.sharex.filetransfer.jsFileResultSize' : (result) => result.size,
        'com.teachmint.sharex.filetransfer.jsFileResultType' : (result) => result.type,
        'com.teachmint.sharex.filetransfer.jsFileResultBytes' : (result) => result.bytes,
        'com.teachmint.sharex.filetransfer.jsToInt8Array' : 
            (uint8Array) => {
                const len = uint8Array.length;
                const arr = new Int8Array(uint8Array.buffer, uint8Array.byteOffset, len);
                return arr;
            }
            ,
        'com.teachmint.sharex.filetransfer.jsArrayLength' : (arr) => arr.length,
        'com.teachmint.sharex.filetransfer.jsArrayGet' : (arr, i) => arr[i],
        'com.teachmint.sharex.share.shared.overrideBrowserLanguages' : (tag) => { {
                    if (!window.__systemLanguages) {
                        var system = window.navigator.languages;
                        window.__systemLanguages = (system && system.length)
                            ? Array.prototype.slice.call(system)
                            : [window.navigator.language || 'en'];
                    }
                    var languages = (tag == null)
                        ? window.__systemLanguages
                        : [tag].concat(window.__systemLanguages);
                    Object.defineProperty(window.navigator, 'languages', {
                        configurable: true,
                        get: function () { return languages; }
                    });
                    Object.defineProperty(window.navigator, 'language', {
                        configurable: true,
                        get: function () { return languages[0]; }
                    });
                } },
        'com.teachmint.sharex.share.shared.readStoredLanguage' : () => window.localStorage.getItem('app_language_code'),
        'com.teachmint.sharex.share.shared.writeStoredLanguage' : (value) => { {
                    if (value == null) window.localStorage.removeItem('app_language_code');
                    else window.localStorage.setItem('app_language_code', value);
                } },
        'com.teachmint.sharex.share.shared.bridgeAttachTrackToVideoElement' : 
            (trackId) => {
              if (typeof document === "undefined") return;
              const root = globalThis;
              const bridge = root.__sharexWebRtcBridge;
              if (!bridge || !bridge.tracks) return;
              const topInsetPxRaw = Number(root.__sharexVideoOverlayInsetTopPx || 0);
              const topInsetPx = Number.isFinite(topInsetPxRaw) ? Math.max(0, topInsetPxRaw) : 0;
              const bottomInsetPxRaw = Number(root.__sharexVideoOverlayInsetBottomPx || 0);
              const bottomInsetPx = Number.isFinite(bottomInsetPxRaw) ? Math.max(0, bottomInsetPxRaw) : 0;
              const totalInset = topInsetPx + bottomInsetPx;
              const viewportHeight = totalInset > 0 ? ("calc(100vh - " + totalInset + "px)") : "100vh";
        
              const findAttachRoot = () => {
                const queue = [document];
                while (queue.length > 0) {
                  const current = queue.shift();
                  if (!current || !current.querySelectorAll) continue;
        
                  const canvases = current.querySelectorAll("canvas");
                  if (canvases && canvases.length > 0) {
                    const nodeRoot = canvases[0].getRootNode ? canvases[0].getRootNode() : document;
                    if (nodeRoot && nodeRoot.appendChild) return nodeRoot;
                  }
        
                  const all = current.querySelectorAll("*");
                  all.forEach((el) => {
                    if (el && el.shadowRoot) queue.push(el.shadowRoot);
                  });
                }
                return document.body || document.documentElement || document;
              };
        
              const findVideoElement = () => {
                const known = root.__sharexRemoteVideoOverlayEl;
                if (known && known.isConnected) return known;
        
                const queue = [document];
                while (queue.length > 0) {
                  const current = queue.shift();
                  if (!current || !current.querySelectorAll) continue;
        
                  const match = current.querySelector("#sharex-remote-video-overlay");
                  if (match) return match;
        
                  const all = current.querySelectorAll("*");
                  all.forEach((el) => {
                    if (el && el.shadowRoot) queue.push(el.shadowRoot);
                  });
                }
        
                return null;
              };
        
              const attachRoot = findAttachRoot();
              const elementId = "sharex-remote-video-overlay";
              let video = findVideoElement();
              if (!video) {
                video = document.createElement("video");
                video.id = elementId;
                video.autoplay = true;
                video.muted = true;
                video.playsInline = true;
                video.style.position = "fixed";
                video.style.left = "0";
                video.style.top = topInsetPx + "px";
                video.style.width = "100vw";
                video.style.height = viewportHeight;
                video.style.objectFit = "contain";
                video.style.background = "transparent";
                video.style.pointerEvents = "none";
                video.style.zIndex = "2147483647";
                video.style.display = "none";
                attachRoot.appendChild(video);
              } else if (video.parentNode !== attachRoot && attachRoot && attachRoot.appendChild) {
                attachRoot.appendChild(video);
              }
              root.__sharexRemoteVideoOverlayEl = video;
        
              let stream = null;
              const streamId = bridge.trackToStream ? bridge.trackToStream[trackId] : null;
              if (streamId && bridge.streams && bridge.streams[streamId]) {
                stream = bridge.streams[streamId];
              }
        
              if (!stream) {
                const track = bridge.tracks[trackId];
                if (!track) {
                  console.warn("sharex: remote track not found in bridge", trackId);
                  return;
                }
                stream = new MediaStream([track]);
              }
        
              video.srcObject = stream;
              video.style.setProperty("position", "fixed", "important");
              video.style.setProperty("left", "0", "important");
              video.style.setProperty("top", topInsetPx + "px", "important");
              video.style.setProperty("width", "100vw", "important");
              video.style.setProperty("height", viewportHeight, "important");
              video.style.setProperty("object-fit", "contain", "important");
              video.style.setProperty("pointer-events", "none", "important");
              video.style.setProperty("opacity", "1", "important");
              video.style.setProperty("visibility", "visible", "important");
              video.style.setProperty("z-index", "2147483647", "important");
              video.style.setProperty("display", "block", "important");
              console.log("sharex: attached remote track to video element", {
                trackId,
                parentTag: video.parentElement ? video.parentElement.tagName : null,
                parentId: video.parentElement ? video.parentElement.id : null,
                rootType: video.getRootNode ? (video.getRootNode().toString ? video.getRootNode().toString() : "root") : "unknown"
              });
              const maybePromise = video.play ? video.play() : null;
              if (maybePromise && typeof maybePromise.catch === "function") {
                maybePromise.catch((e) => {
                  console.warn("sharex: video.play() rejected", e);
                });
              }
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeSetVideoOverlayViewportInsetTop' : 
            (px) => {
              if (typeof document === "undefined") return;
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root) return;
              const dpr = window.devicePixelRatio || 1;
              const raw = Number(px);
              const topInsetPx = Number.isFinite(raw) ? Math.max(0, Math.round(raw / dpr)) : 0;
              root.__sharexVideoOverlayInsetTopPx = topInsetPx;
        
              const findVideoElement = () => {
                const known = root.__sharexRemoteVideoOverlayEl;
                if (known && known.isConnected) return known;
        
                const queue = [document];
                while (queue.length > 0) {
                  const current = queue.shift();
                  if (!current || !current.querySelectorAll) continue;
        
                  const match = current.querySelector("#sharex-remote-video-overlay");
                  if (match) return match;
        
                  const all = current.querySelectorAll("*");
                  all.forEach((el) => {
                    if (el && el.shadowRoot) queue.push(el.shadowRoot);
                  });
                }
                return null;
              };
        
              const video = findVideoElement();
              if (!video) return;
              root.__sharexRemoteVideoOverlayEl = video;
              const bottomInsetPx = Number(root.__sharexVideoOverlayInsetBottomPx || 0);
              const totalInset = topInsetPx + (Number.isFinite(bottomInsetPx) ? Math.max(0, bottomInsetPx) : 0);
              const viewportHeight = totalInset > 0 ? ("calc(100vh - " + totalInset + "px)") : "100vh";
              video.style.setProperty("position", "fixed", "important");
              video.style.setProperty("left", "0", "important");
              video.style.setProperty("top", topInsetPx + "px", "important");
              video.style.setProperty("width", "100vw", "important");
              video.style.setProperty("height", viewportHeight, "important");
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeSetVideoOverlayViewportInsetBottom' : 
            (px) => {
              if (typeof document === "undefined") return;
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root) return;
              const dpr = window.devicePixelRatio || 1;
              const raw = Number(px);
              const bottomInsetCss = Number.isFinite(raw) ? Math.max(0, Math.round(raw / dpr)) : 0;
              root.__sharexVideoOverlayInsetBottomPx = bottomInsetCss;
        
              const findVideoElement = () => {
                const known = root.__sharexRemoteVideoOverlayEl;
                if (known && known.isConnected) return known;
        
                const queue = [document];
                while (queue.length > 0) {
                  const current = queue.shift();
                  if (!current || !current.querySelectorAll) continue;
        
                  const match = current.querySelector("#sharex-remote-video-overlay");
                  if (match) return match;
        
                  const all = current.querySelectorAll("*");
                  all.forEach((el) => {
                    if (el && el.shadowRoot) queue.push(el.shadowRoot);
                  });
                }
                return null;
              };
        
              const video = findVideoElement();
              if (!video) return;
              root.__sharexRemoteVideoOverlayEl = video;
              const topInsetPx = Number(root.__sharexVideoOverlayInsetTopPx || 0);
              const totalInset = (Number.isFinite(topInsetPx) ? Math.max(0, topInsetPx) : 0) + bottomInsetCss;
              const viewportHeight = totalInset > 0 ? ("calc(100vh - " + totalInset + "px)") : "100vh";
              video.style.setProperty("position", "fixed", "important");
              video.style.setProperty("left", "0", "important");
              video.style.setProperty("top", (Number.isFinite(topInsetPx) ? Math.max(0, topInsetPx) : 0) + "px", "important");
              video.style.setProperty("width", "100vw", "important");
              video.style.setProperty("height", viewportHeight, "important");
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeHideVideoElement' : 
            () => {
              if (typeof document === "undefined") return;
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              const findVideoElement = () => {
                const known = root && root.__sharexRemoteVideoOverlayEl;
                if (known && known.isConnected) return known;
        
                const queue = [document];
                while (queue.length > 0) {
                  const current = queue.shift();
                  if (!current || !current.querySelectorAll) continue;
        
                  const match = current.querySelector("#sharex-remote-video-overlay");
                  if (match) return match;
        
                  const all = current.querySelectorAll("*");
                  all.forEach((el) => {
                    if (el && el.shadowRoot) queue.push(el.shadowRoot);
                  });
                }
                return null;
              };
        
              const video = findVideoElement();
              if (!video) return;
              try {
                if (video.pause) video.pause();
              } catch (_) {}
              video.srcObject = null;
              video.style.display = "none";
              if (root) {
                root.__sharexRemoteVideoOverlayEl = video;
              }
              console.log("sharex: remote video element hidden");
            }
            ,
        'com.teachmint.sharex.share.shared.browserCryptoRandomHex16' : 
            () => {
              const bytes = new Uint8Array(16);
              crypto.getRandomValues(bytes);
              return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
            }
            ,
        'com.teachmint.sharex.share.shared.browserLikelyOnline' : 
            () => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root) return true;
        
              const nav = root.navigator;
              if (!nav) return true;
        
              // navigator.onLine is known to be false-negative on some LAN/no-internet setups.
              if (nav.onLine === true) return true;
        
              const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
              if (connection) {
                if (typeof connection.type === "string" && connection.type !== "none") return true;
                if (typeof connection.downlink === "number" && connection.downlink > 0) return true;
              }
        
              // If the app is already loaded from http/https, don't block the UI as fully offline.
              const location = root.location;
              const protocol = location && typeof location.protocol === "string" ? location.protocol : "";
              return protocol === "http:" || protocol === "https:";
            }
            ,
        'com.teachmint.sharex.share.shared.browserNowMillisAsDouble' : () => Date.now(),
        'com.teachmint.sharex.share.shared.browserIsSecureOrigin' : 
            () => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root || !root.location) return false;
              const protocol = typeof root.location.protocol === "string" ? root.location.protocol : "";
              return protocol === "https:";
            }
            ,
        'com.teachmint.sharex.share.shared.browserHasGetDisplayMedia' : 
            () => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              const nav = root && root.navigator ? root.navigator : null;
              return !!(nav && nav.mediaDevices && typeof nav.mediaDevices.getDisplayMedia === "function");
            }
            ,
        'com.teachmint.sharex.share.shared.browserConnectedWifiNameOrNull' : 
            () => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root || !root.navigator) return null;
        
              const nav = root.navigator;
              const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
              if (!connection) return null;
        
              if (typeof connection.ssid === "string") {
                const ssid = connection.ssid.trim();
                if (ssid.length > 0) return ssid;
              }
        
              if (typeof connection.type === "string" && connection.type.toLowerCase() === "wifi") {
                return "Wi-Fi";
              }
        
              return null;
            }
            ,
        'com.teachmint.sharex.share.shared.browserConnectionTypeOrNull' : 
            () => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              const nav = root && root.navigator ? root.navigator : null;
              const connection = nav ? (nav.connection || nav.mozConnection || nav.webkitConnection) : null;
              if (!connection || typeof connection.type !== "string") return null;
              return connection.type.toLowerCase();
            }
            ,
        'com.teachmint.sharex.share.shared.ensureBridgeStore' : 
            () => {
              const root = globalThis;
              if (!root.__sharexWebRtcBridge) {
                root.__sharexWebRtcBridge = {
                  nextId: 1,
                  pcs: {},
                  tracks: {},
                  streams: {},
                  trackToStream: {},
                  iceQueues: {},
                  remoteTrackQueues: {},
                  results: {}
                };
              }
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeCreatePeerConnection' : 
            (configJson) => {
              const root = globalThis;
              if (!root.__sharexWebRtcBridge) {
                root.__sharexWebRtcBridge = {
                  nextId: 1,
                  pcs: {},
                  tracks: {},
                  streams: {},
                  trackToStream: {},
                  iceQueues: {},
                  remoteTrackQueues: {},
                  results: {}
                };
              }
              const s = root.__sharexWebRtcBridge;
              const pcId = "pc-" + (s.nextId++);
              let rtcConfig = {};
              try {
                const parsed = JSON.parse(configJson || "{}");
                rtcConfig = { iceServers: parsed.iceServers || [] };
              } catch (_) {
                rtcConfig = {};
              }
        
              const pc = new RTCPeerConnection(rtcConfig);
              s.pcs[pcId] = pc;
              s.iceQueues[pcId] = [];
              s.remoteTrackQueues[pcId] = [];
        
              pc.onicecandidate = (event) => {
                if (!event || !event.candidate) return;
                const c = event.candidate;
                s.iceQueues[pcId].push(
                  JSON.stringify({
                    candidate: c.candidate || "",
                    sdpMid: c.sdpMid || "",
                    sdpMLineIndex: typeof c.sdpMLineIndex === "number" ? c.sdpMLineIndex : 0
                  })
                );
              };
        
              pc.ontrack = (event) => {
                if (!event || !event.track) return;
                const trackId = "track-" + (s.nextId++);
                s.tracks[trackId] = event.track;
                if (event.streams && event.streams.length > 0) {
                  const streamId = "stream-" + (s.nextId++);
                  s.streams[streamId] = event.streams[0];
                  s.trackToStream[trackId] = streamId;
                }
                s.remoteTrackQueues[pcId].push(trackId);
              };
        
              return pcId;
            }
            ,
        'com.teachmint.sharex.share.shared.bridgePollIceCandidate' : 
            (pcId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.iceQueues[pcId] || s.iceQueues[pcId].length === 0) return "";
              return s.iceQueues[pcId].shift() || "";
            }
            ,
        'com.teachmint.sharex.share.shared.bridgePollRemoteTrack' : 
            (pcId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.remoteTrackQueues[pcId] || s.remoteTrackQueues[pcId].length === 0) return "";
              return s.remoteTrackQueues[pcId].shift() || "";
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeTakeResult' : 
            (requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.results) return "";
              const result = s.results[requestId];
              if (!result) return "";
              delete s.results[requestId];
              return result;
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginStartScreenCapture' : 
            (requestId) => {
              const root = globalThis;
              if (!root.__sharexWebRtcBridge) {
                root.__sharexWebRtcBridge = { nextId: 1, pcs: {}, tracks: {}, streams: {}, trackToStream: {}, iceQueues: {}, remoteTrackQueues: {}, results: {} };
              }
              const s = root.__sharexWebRtcBridge;
              // A flag left over from a previous share would tear this one down the
              // moment the Kotlin side polled it.
              s.captureEndedExternally = false;
              (async () => {
                try {
                  if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
                    throw new Error("getDisplayMedia is not available in this browser");
                  }
                  // Request audio too: when the user picks a tab/app that produces sound
                  // (Chrome tab share, browser app with audio), the browser bundles the
                  // audio track with the video. If the picked source has no audio, the
                  // browser silently omits it, which we handle below.
                  // systemAudio:"include" tells Chrome to offer the system audio
                  // checkbox even when sharing a full screen (not just a tab).
                  // Cap the capture size — scaled by the display's pixel density.
                  //
                  // The flat 1920x1080 cap dates from when this sender encoded in
                  // software: unconstrained Retina capture (3456x2232, 7.7 megapixels)
                  // starved that encoder and the receiver drew 1-3 fps. Encoding moved
                  // to hardware H.264 since (see setCodecPreferences below), which
                  // removes the reason for the cap but not its cost — and the cost was
                  // measured, on a Retina Mac casting to a 4K panel:
                  //
                  //   3456-wide screen, height-bound by the 1080 cap, arrives 1670x1078.
                  //   A x0.48 non-integer squeeze at capture, then a x2.3 stretch on the
                  //   panel. Text lands soft, and every glyph stroke picks up gray
                  //   fringes that the panel's edge enhancement reads as extra weight —
                  //   users see "thicker letters" on the panel than on the Mac, on the
                  //   Mac cast only. A 1:1-captured 1920x1080 Windows screen through the
                  //   same encoder, network and panel keeps its sharpness and weight,
                  //   which pins the damage on the resample, not the pipeline.
                  //
                  // So scale the cap by devicePixelRatio, clamped to 2: a Retina Mac
                  // (dpr 2) may now capture its full 3456x2232 and a 4K/200% Windows
                  // laptop its full 3840x2160, while every standard-density machine
                  // (dpr 1) keeps the exact constraint it had before this change. The
                  // dpr describes the display the page is on, not necessarily the one
                  // the user picks in the share dialog — but sharing the screen you are
                  // presenting from is the overwhelmingly common case, and a mismatch
                  // only reproduces today's cap, never exceeds the 2x ceiling.
                  //
                  // The pixel cost lands on the encoder budget instead of on capture:
                  // sender parameters below scale maxBitrate with the encoded pixel
                  // count and keep a hard 3840-wide encode ceiling.
                  const dpr = Math.min(2, Math.max(1, (root.devicePixelRatio || 1)));
                  const MAX_CAPTURE_WIDTH = Math.round(1920 * dpr);
                  const MAX_CAPTURE_HEIGHT = Math.round(1080 * dpr);
                  const TARGET_CAPTURE_FPS = 30;
                  const constraints = {
                    video: {
                      width: { max: MAX_CAPTURE_WIDTH },
                      height: { max: MAX_CAPTURE_HEIGHT },
                      frameRate: { ideal: TARGET_CAPTURE_FPS, max: TARGET_CAPTURE_FPS },
                      // The modal already asked for the whole screen and offers nothing
                      // else, so the browser picker that follows should not open on its
                      // Tab pane and make the visitor answer the same question twice.
                      // This is a hint, not a rule: browsers still show every pane, and
                      // one that does not know the hint ignores it.
                      displaySurface: "monitor",
                    },
                    // Take the audio raw. Left as a bare `audio: true`, Chrome runs the
                    // voice-processing chain on the track — and that chain is tuned for
                    // a microphone in a room, not for music or a video's soundtrack.
                    // Auto gain control is the audible one: it rides the level, pushing
                    // quiet passages up and pulling loud ones down, so shared media
                    // swells and fades instead of holding its mix. Echo cancellation and
                    // noise suppression have nothing to cancel here and only chew on the
                    // signal. Stereo at 48kHz is what the source already is.
                    audio: {
                      autoGainControl: false,
                      echoCancellation: false,
                      noiseSuppression: false,
                      channelCount: 2,
                      sampleRate: 48000,
                    },
                  };
                  try { constraints.systemAudio = "include"; } catch(_) {}
                  const stream = await navigator.mediaDevices.getDisplayMedia(constraints);
                  // Nobody is waiting for this any more: the Kotlin side gave up on the
                  // picker, or was torn down while it stood open. The stream is live all
                  // the same, so stop it here rather than leave the browser capturing
                  // for a share that no longer exists.
                  if (s.abandoned && s.abandoned[requestId]) {
                    delete s.abandoned[requestId];
                    console.log("[ShareX] screen capture abandoned before a source was chosen; stopping it");
                    try { stream.getTracks().forEach((t) => { try { t.stop(); } catch (_) {} }); } catch (_) {}
                    return;
                  }
                  console.log("[ShareX] getDisplayMedia returned " +
                    (stream.getAudioTracks().length) + " audio track(s), " +
                    (stream.getVideoTracks().length) + " video track(s)");
                  const videoTracks = stream.getVideoTracks ? stream.getVideoTracks() : [];
                  const videoTrack = videoTracks && videoTracks.length > 0 ? videoTracks[0] : null;
                  if (!videoTrack) {
                    throw new Error("No video track returned by getDisplayMedia");
                  }
        
                  // A slept display stops feeding getDisplayMedia. macOS runs its own
                  // display-idle timer (2 minutes on some machines) and when it fires
                  // mid-share the capture goes quiet: frames stop, the encoder stops,
                  // and BOTH media streams flatline while ICE still reports
                  // "connected" -- so nothing tears the session down and nothing
                  // rebuilds it. The receiver just sits on a frozen picture.
                  //
                  // Measured against a panel: display off at 13:07:16, media dead at
                  // 13:07:20, display back on at 13:08:52, media back at 13:09:44.
                  // 96s of idle cost 124s of dead share, and the session only returned
                  // by being torn down and renegotiated -- coming back at the wrong
                  // geometry, which costs the panel a decoder re-init too.
                  //
                  // Chrome holds a NoIdleSleepAssertion while peer connections are
                  // live, but that blocks *system* sleep, not *display* sleep; its
                  // "Video Wake Lock" covers playing <video> elements, not screen
                  // capture. Nothing in the stack asks for the display, so ask here.
                  //
                  // The UA releases this lock whenever the document goes hidden, so a
                  // one-shot request is not enough -- re-acquire on visibilitychange
                  // for as long as a share is wanted. Requires a secure context and is
                  // absent on Firefox, so every failure is non-fatal: the share still
                  // runs, it just stays vulnerable to display sleep.
                  (() => {
                    if (!root.__sharexWakeLock) {
                      const w = {
                        sentinel: null,
                        wanted: false,
                        acquiring: false,
                        acquire: async () => {
                          if (!w.wanted) return;
                          if (w.sentinel && !w.sentinel.released) return;
                          // request() is async, and both a share start and a
                          // visibilitychange can call in before the first one settles.
                          // Without this guard each caller gets its own sentinel and
                          // only the last is ever stored -- leaking a held lock that
                          // nothing can release, which keeps the display awake for the
                          // life of the tab.
                          if (w.acquiring) return;
                          if (!navigator.wakeLock) {
                            console.log("[ShareX] no Screen Wake Lock API; display sleep will stall the share");
                            return;
                          }
                          if (document.visibilityState !== "visible") return;
                          w.acquiring = true;
                          try {
                            const held = await navigator.wakeLock.request("screen");
                            if (!w.wanted) {
                              // Released while the request was in flight.
                              try { held.release(); } catch (_) {}
                              return;
                            }
                            w.sentinel = held;
                            w.sentinel.addEventListener("release", () => {
                              // Fires on tab-hide as well as on our own release; the
                              // visibilitychange handler below re-takes it if wanted.
                              console.log("[ShareX] screen wake lock released (wanted=" + w.wanted + ")");
                            });
                            console.log("[ShareX] screen wake lock acquired");
                          } catch (e) {
                            console.log("[ShareX] screen wake lock request failed: " + e);
                          } finally {
                            w.acquiring = false;
                          }
                        },
                        release: () => {
                          w.wanted = false;
                          const held = w.sentinel;
                          w.sentinel = null;
                          if (held && held.release) {
                            try { held.release(); } catch (_) {}
                          }
                        },
                      };
                      root.__sharexWakeLock = w;
                      document.addEventListener("visibilitychange", () => {
                        if (document.visibilityState === "visible") w.acquire();
                      });
                    }
                    root.__sharexWakeLock.wanted = true;
                    root.__sharexWakeLock.acquire();
                  })();
        
                  // "detail" tells the encoder to spend its bits on per-pixel crispness
                  // rather than framerate. This hint used to be "motion" for the opposite
                  // reason — a busy screen turning into a slideshow — but that was while
                  // protecting framerate was the only lever left. "motion" only buys
                  // frames by softening text, and what these panels mostly show is
                  // text: code, documents, slides. The encode geometry is seeded below
                  // and thereafter owned by ContentAwareQualityController, with the
                  // sender running "maintain-resolution" -- so this hint governs how the
                  // available bits are spent across a frame whose size the controller
                  // has already chosen, not whether frames arrive at all. A 1080p share drawn full screen on a 4K panel is
                  // already upscaled 1.7x, so it has no crispness to spare.
                  try { videoTrack.contentHint = "detail"; } catch (_) {}
                  try {
                    const settings = videoTrack.getSettings ? videoTrack.getSettings() : {};
                    console.log("[ShareX] capture settings: " + settings.width + "x" + settings.height +
                      " @" + settings.frameRate + "fps contentHint=" + videoTrack.contentHint);
                  } catch (_) {}
        
                  const streamId = "stream-" + (s.nextId++);
                  const trackId = "track-" + (s.nextId++);
                  s.streams[streamId] = stream;
                  s.tracks[trackId] = videoTrack;
                  s.trackToStream[trackId] = streamId;
        
                  videoTrack.onended = () => {
                    try { videoTrack.stop(); } catch (_) {}
                    // "Stop sharing" from the browser's own bar lands here. Nothing in
                    // the app asked for it, so raise a flag for the Kotlin side to poll:
                    // it still thinks it is sharing, and the host still has our tile up.
                    // A track stopped by bridgeStopTrack does NOT fire this event, so the
                    // flag only ever means "the browser ended it".
                    s.captureEndedExternally = true;
                    if (root.__sharexWakeLock) root.__sharexWakeLock.release();
                    const sid = s.trackToStream[trackId];
                    if (sid && s.streams[sid] && s.streams[sid].getTracks) {
                      s.streams[sid].getTracks().forEach((t) => { try { t.stop(); } catch (_) {} });
                    }
                    delete s.trackToStream[trackId];
                    delete s.streams[streamId];
                    delete s.tracks[trackId];
                  };
        
                  // Register the optional audio track (system/tab audio) so it can be
                  // attached to the peer connection in the same media stream as the
                  // video, keeping them in sync on the remote side.
                  let audioTrackId = null;
                  const audioTracks = stream.getAudioTracks ? stream.getAudioTracks() : [];
                  if (audioTracks && audioTracks.length > 0) {
                    const audioTrack = audioTracks[0];
                    audioTrackId = "track-" + (s.nextId++);
                    s.tracks[audioTrackId] = audioTrack;
                    s.trackToStream[audioTrackId] = streamId;
                    console.log("[ShareX] Audio track captured: id=" + audioTrackId +
                      ", label=" + audioTrack.label + ", enabled=" + audioTrack.enabled +
                      ", muted=" + audioTrack.muted + ", readyState=" + audioTrack.readyState);
                    // A browser may quietly ignore any of the processing constraints, so
                    // report what it actually settled on. autoGainControl=true here means
                    // the level is still being ridden and the swelling is expected.
                    try {
                      const aSettings = audioTrack.getSettings ? audioTrack.getSettings() : {};
                      console.log("[ShareX] audio settings: autoGainControl=" + aSettings.autoGainControl +
                        " echoCancellation=" + aSettings.echoCancellation +
                        " noiseSuppression=" + aSettings.noiseSuppression +
                        " channels=" + aSettings.channelCount +
                        " sampleRate=" + aSettings.sampleRate);
                    } catch (_) {}
                  } else {
                    console.warn("[ShareX] No audio track returned by getDisplayMedia. " +
                      "Audio sharing requires: Chrome tab share (with audio checkbox), " +
                      "or full-screen share with system audio enabled.");
                  }
        
                  s.results[requestId] = JSON.stringify({
                    ok: true,
                    trackId: trackId,
                    audioTrackId: audioTrackId
                  });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Screen capture failed";
                  // Carry the DOMException name across: Chrome reports a dismissed
                  // picker as NotAllowedError whose message is just "Permission denied",
                  // which is indistinguishable from a real refusal by text alone.
                  const name = (e && e.name) || "";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message, errorName: name });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeAbandonScreenCapture' : 
            (requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s) return;
              if (!s.abandoned) s.abandoned = {};
              s.abandoned[requestId] = true;
              // A result that arrived between the last poll and this call would
              // otherwise sit in the store forever, holding a track id nothing stops.
              const pending = s.results && s.results[requestId];
              if (pending) {
                delete s.results[requestId];
                try {
                  const parsed = JSON.parse(pending);
                  [parsed.trackId, parsed.audioTrackId].forEach((id) => {
                    if (!id) return;
                    const track = s.tracks[id];
                    if (track) { try { track.stop(); } catch (_) {} }
                    delete s.tracks[id];
                    delete s.trackToStream[id];
                  });
                } catch (_) {}
              }
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginCreateOffer' : 
            (pcId, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
        
              (async () => {
                try {
                  const offer = await pc.createOffer({ offerToReceiveAudio: true, offerToReceiveVideo: true });
                  s.results[requestId] = JSON.stringify({
                    ok: true,
                    type: offer.type || "offer",
                    sdp: offer.sdp || ""
                  });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to create offer";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginCreateAnswer' : 
            (pcId, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
        
              (async () => {
                try {
                  const answer = await pc.createAnswer();
                  s.results[requestId] = JSON.stringify({
                    ok: true,
                    type: answer.type || "answer",
                    sdp: answer.sdp || ""
                  });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to create answer";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginSetLocalDescription' : 
            (pcId, type, sdp, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
              (async () => {
                try {
                  await pc.setLocalDescription({ type: type, sdp: sdp });
                  s.results[requestId] = JSON.stringify({ ok: true });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to set local description";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginSetRemoteDescription' : 
            (pcId, type, sdp, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
              (async () => {
                try {
                  await pc.setRemoteDescription({ type: type, sdp: sdp });
                  s.results[requestId] = JSON.stringify({ ok: true });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to set remote description";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginAddIceCandidate' : 
            (pcId, sdpMid, sdpMLineIndex, candidate, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
              (async () => {
                try {
                  const init = {
                    candidate: candidate || "",
                    sdpMLineIndex: Number(sdpMLineIndex)
                  };
                  if (sdpMid && sdpMid.length > 0) {
                    init.sdpMid = sdpMid;
                  }
                  await pc.addIceCandidate(init);
                  s.results[requestId] = JSON.stringify({ ok: true });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to add ICE candidate";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeAddLocalTrack' : 
            (pcId, trackId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.pcs || !s.tracks) return "WebRTC bridge is not initialized";
              const pc = s.pcs[pcId];
              if (!pc) return "Peer connection not found: " + pcId;
              const track = s.tracks[trackId];
              if (!track) return "Track not found: " + trackId;
              try {
                const streamId = s.trackToStream ? s.trackToStream[trackId] : null;
                const stream = streamId ? s.streams[streamId] : null;
                const sender = stream ? pc.addTrack(track, stream) : pc.addTrack(track);
                console.log("[ShareX] addTrack: kind=" + track.kind + " id=" + trackId +
                  " enabled=" + track.enabled + " readyState=" + track.readyState +
                  " stream=" + (streamId || "none"));
                // Pin the encode geometry rather than letting the browser ladder it.
                // Left to itself Chrome's adapter walks resolution up and down under
                // pressure, and on a link with jitter that is a step every few seconds.
                // Every step re-inits the receiving panel's hardware decoder, so the
                // picture tears itself down and rebuilds instead of merely getting
                // softer — measured on a panel: 40 decoder re-inits in eight minutes,
                // walking 416 -> 624 -> 834 -> 1250 -> 1670 and back.
                //
                // Changing resolution rarely, and deliberately, is what keeps that cost
                // bounded: a Retina screen share is far more pixels than most links can
                // carry at speed, so seed it at SEED_ENCODE_WIDTH here and let
                // ContentAwareQualityController move it only between fixed rungs and only
                // after its dwell has elapsed. That is the difference from the browser's
                // own adapter -- not that geometry never changes, but that it changes on a
                // schedule the receiving decoder can absorb.
                if (sender && track.kind === "video" && sender.getParameters) {
                  (async () => {
                    try {
                      // Encode at the captured resolution up to a 3840-wide ceiling.
                      //
                      // The capture constraint now scales with devicePixelRatio (see
                      // startScreenCapture), so a Retina Mac hands us 3456x2232 instead
                      // of a pre-squeezed 1670x1078. Scaling that back down here to a
                      // fixed 1920 would re-create the exact resample this change
                      // exists to remove — on a 4K panel a 3456-wide encode is drawn at
                      // a near-1:1 x1.11, versus the x2.3 stretch of the old squeezed
                      // capture, and the difference is text with its stroke weight
                      // intact. The ceiling only bites above 3840 (dpr is clamped so
                      // capture cannot exceed it today); standard-density captures
                      // (<=1920 wide) hit scale=1 and behave exactly as before.
                      //
                      // The bitrate budget grows with the encoded pixel count instead
                      // of staying flat: 2.5 Mbps was budgeted for a 1920x1080 canvas,
                      // and holding it while quadrupling the pixels would starve the
                      // quantizer and blur the very text this is for. Capped at 6 Mbps
                      // to stay inside the host's SDP ceiling (x-google-max-bitrate=6500
                      // for web clients) — and mostly-static screens sit far below
                      // either number anyway; a healthy 1670x1078 desktop cast measured
                      // 20-50 kbps at 29 fps with motion peaks in the hundreds.
                      //
                      // On a path that cannot carry motion at this size the cost used to
                      // land entirely on framerate, via degradationPreference
                      // "maintain-resolution", on the reasoning that for text that is
                      // the right half to sacrifice. Measured against a panel, it is
                      // not. A Retina Mac holding 3456x1880 arrived at 384-702 kbps and
                      // 2-11 fps with ~75% of frames dropped -- about 0.05 bits per
                      // pixel, where legible screen content needs 0.1-0.2. Resolution
                      // sat perfectly still while the picture stopped being a picture,
                      // and it behaved the same over a TURN relay
                      // (availableOutgoingBitrate=1.2 Mbps) and over direct p2p at 17ms.
                      // Nothing on the receiving end can correct this: the host cannot
                      // bound a browser's frame size over SDP (advertising H.264 Level
                      // 4.2 was tried and Chrome ignored it), and a browser has no
                      // sender-side quality controller of its own.
                      //
                      // "balanced" was the answer to that, on the reasoning that the
                      // encoder would ladder resolution down once the link could not
                      // carry the pixel count. Measured across two sessions, it does
                      // not: resolution sat frozen at 3024x1964 for ~90 consecutive
                      // samples while framerate collapsed to 2 fps. libwebrtc has
                      // historically disabled its quality scaler for screencast
                      // content, which would make the setting a silent no-op here --
                      // and having now tried the preference in both directions with the
                      // same outcome, the conclusion is that no value of it ladders a
                      // screen share.
                      //
                      // So stop asking. ContentAwareQualityController sizes the encode
                      // itself, which needs no cooperation from the browser.
                      //
                      // "maintain-framerate" was tried next and is wrong for this
                      // content. It licences the encoder to shed pixels, and measured
                      // against a panel it did: a 3024x1964 capture arrived at
                      // 1134x734 -- a 2.67x reduction the browser chose on its own,
                      // upscaled 2.93x by the panel -- while holding 16-21 fps at
                      // 0.0058-0.086 bits per pixel. Legible screen text needs
                      // 0.10-0.20 bpp. The encoder had spent the entire budget on
                      // smoothness nobody asked for; a screen share is read, not
                      // watched, and 6 fps is already a 167ms frame interval.
                      //
                      // So back to "maintain-resolution", but this time paired with a
                      // geometry cheap enough that the encoder should never need to
                      // degrade at all: ~2.6 MP at 6 fps instead of 5.9 MP at 30. That
                      // is ~16 Mpixel/s, which removes the CPU question, and roughly
                      // 1.9 Mbps at a legible 0.12 bpp on a path that sustains ~2. The
                      // 0.25 fps collapse this setting caused before was measured at
                      // 30 fps against the full 5.9 MP frame, where the encoder needed
                      // ~10 Mbps and had to shed something; there is far less room to
                      // fall from 6 fps, and framerate remains the only thing it may
                      // take, never the resolution this content is judged on.
                      //
                      // The panel logs an initDecodeInternal on every resolution
                      // change, so a healthy session prints exactly one. Two or more
                      // means something is still moving the geometry.
                      //
                      // The opening geometry only. ContentAwareQualityController no
                      // longer holds the session at a fixed size -- it measures what
                      // frames actually cost and sizes from the path's real budget -- so
                      // these are the guess the stream runs on for the few seconds its
                      // cost and budget windows take to fill, not the geometry it ends
                      // at. Mirror of SEED_ENCODE_WIDTH in that file; the two must stay
                      // in step, because a seed that disagrees with where the controller
                      // settles costs the panel one extra decoder re-init early on.
                      //
                      // Deliberately the middle of the range rather than either end:
                      // opening too wide starves a thin link during exactly the window
                      // where nothing has been measured yet, and opening too narrow
                      // wastes a fat one and needs an upgrade step to recover, which the
                      // controller's dwell and upgrade margin make slow on purpose.
                      //
                      // Capture is still taken at full devicePixelRatio-scaled size and
                      // downscaled here rather than constrained smaller at
                      // getDisplayMedia: the capture-side resample is the one that
                      // damages text (see the note on the capture constraints above),
                      // and this way the source stays available at full size -- which the
                      // controller can now ask for, on a link that affords it.
                      const SEED_ENCODE_WIDTH = 2016;
                      const SEED_FPS = 24;
                      const BASE_BITRATE = 2500000;
                      const BASE_PIXELS = 1920 * 1080;
                      const MAX_BITRATE_CEILING = 6000000;
                      const ENCODINGS_POLL_MS = 100;
                      const ENCODINGS_MAX_WAIT_MS = 5000;
                      let capturedWidth = 0;
                      let capturedHeight = 0;
                      try {
                        const st = track.getSettings ? track.getSettings() : {};
                        capturedWidth = st.width || 0;
                        capturedHeight = st.height || 0;
                      } catch (_) {}
                      const scale = capturedWidth > SEED_ENCODE_WIDTH
                        ? capturedWidth / SEED_ENCODE_WIDTH
                        : 1;
                      const encodedPixels = (capturedWidth * capturedHeight) / (scale * scale);
                      const maxBitrate = Math.min(
                        MAX_BITRATE_CEILING,
                        Math.round(BASE_BITRATE * Math.max(1, encodedPixels / BASE_PIXELS))
                      );
                      // addTrack populates the sender's encodings asynchronously, so a
                      // read taken straight after it can legitimately come back empty.
                      // Replacing that [] with [{}] does not work around it — the length
                      // must match [[SendEncodings]] or setParameters throws
                      // InvalidModificationError and drops every field in this block,
                      // degradationPreference included, for the whole session. Wait for
                      // the encodings to exist instead.
                      let params = sender.getParameters();
                      let waitedMs = 0;
                      while ((!params.encodings || params.encodings.length === 0) &&
                             waitedMs < ENCODINGS_MAX_WAIT_MS) {
                        await new Promise((r) => setTimeout(r, ENCODINGS_POLL_MS));
                        waitedMs += ENCODINGS_POLL_MS;
                        params = sender.getParameters();
                      }
                      if (!params.encodings || params.encodings.length === 0) {
                        console.warn("[ShareX] no RTP encodings after " + waitedMs +
                          "ms; sender params not applied");
                        return;
                      }
                      params.degradationPreference = "maintain-resolution";
                      params.encodings[0].maxBitrate = maxBitrate;
                      params.encodings[0].maxFramerate = SEED_FPS;
                      params.encodings[0].scaleResolutionDownBy = scale;
                      await sender.setParameters(params);
                      let effective = "unknown";
                      try { effective = sender.getParameters().degradationPreference || "unset"; } catch (_) {}
                      console.log("[ShareX] sender params applied: captured=" + capturedWidth +
                        "x" + capturedHeight +
                        " scaleResolutionDownBy=" + scale.toFixed(2) +
                        " maxBitrate=" + maxBitrate + " maxFramerate=" + SEED_FPS + " " +
                        "degradationPreference=" + effective +
                        (waitedMs > 0 ? " (encodings took " + waitedMs + "ms)" : ""));
                      if (effective !== "maintain-resolution") {
                        console.warn("[ShareX] degradationPreference did not stick: wanted " +
                          "maintain-resolution, sender reports " + effective);
                      }
                    } catch (e) {
                      console.warn("[ShareX] Failed to apply sender params: " +
                        ((e && (e.message || e.toString())) || "unknown"));
                    }
                  })();
                }
        
                // Prefer H.264. Chrome encodes VP8/VP9 in software, so a 1080p screen
                // share competes for CPU with everything else the presenter is running
                // — and a starved encoder does not simply get grainy, it sheds
                // resolution and framerate until the picture is unreadable. H.264 has a
                // hardware encoder on essentially every machine that presents from this
                // page, and hardware decode on every Android panel that receives it.
                // Order preference only: if the far end will not take H.264, the rest of
                // the list still follows and negotiation proceeds as before.
                if (sender && track.kind === "video" && pc.getTransceivers) {
                  try {
                    const transceiver = pc.getTransceivers().find((t) => t.sender === sender);
                    const caps = (typeof RTCRtpSender !== "undefined" && RTCRtpSender.getCapabilities)
                      ? RTCRtpSender.getCapabilities("video") : null;
                    const all = (caps && caps.codecs) || [];
                    const isH264 = (c) => /h264/i.test((c && c.mimeType) || "");
                    if (transceiver && transceiver.setCodecPreferences && all.some(isH264)) {
                      transceiver.setCodecPreferences(all.filter(isH264).concat(all.filter((c) => !isH264(c))));
                      console.log("[ShareX] codec preference: H.264 first (" +
                        all.filter(isH264).length + " of " + all.length + " entries)");
                    } else if (all.length > 0) {
                      console.warn("[ShareX] No H.264 advertised by this browser; " +
                        "leaving codec order alone (expect software encoding)");
                    }
                  } catch (e) {
                    console.warn("[ShareX] setCodecPreferences failed: " +
                      ((e && (e.message || e.toString())) || "unknown"));
                  }
                }
        
                // Sample the send side and leave the result where Kotlin can collect
                // it. qualityLimitationReason is the field that separates "the encoder
                // cannot keep up" from "the network cannot" — from the receiving end the
                // two look identical, because both arrive as a small, slow picture — and
                // availableOutgoingBitrate is what the controller sizes the encode
                // against.
                //
                // Rates are differenced here rather than on the Kotlin side because the
                // previous sample and a known interval both already live here, while the
                // collector polls on its own clock: differencing there would divide by
                // whatever the poll happened to catch. Sampling moved to 1s for the
                // controller's benefit, but the console keeps its old 4s cadence — the
                // logs are read by people, and quadrupling them helps nobody.
                if (sender && track.kind === "video" && sender.getStats) {
                  if (!s.statsTimers) s.statsTimers = {};
                  if (!s.encoderStats) s.encoderStats = {};
                  if (!s.statsPrev) s.statsPrev = {};
                  if (s.statsTimers[pcId]) clearInterval(s.statsTimers[pcId]);
                  delete s.statsPrev[pcId];
                  let sampleCount = 0;
                  s.statsTimers[pcId] = setInterval(() => {
                    if (pc.connectionState === "closed") {
                      clearInterval(s.statsTimers[pcId]);
                      delete s.statsTimers[pcId];
                      delete s.encoderStats[pcId];
                      delete s.statsPrev[pcId];
                      return;
                    }
                    sender.getStats().then((report) => {
                      let out = null, pair = null, codec = null, local = null, remote = null, inbound = null;
                      report.forEach((r) => {
                        if (r.type === "outbound-rtp" && r.kind === "video") out = r;
                        if (r.type === "candidate-pair" && r.nominated && r.state === "succeeded") pair = r;
                        if (r.type === "remote-inbound-rtp" && r.kind === "video") inbound = r;
                      });
                      report.forEach((r) => {
                        if (out && r.id === out.codecId) codec = r;
                        if (pair && r.id === pair.localCandidateId) local = r;
                        if (pair && r.id === pair.remoteCandidateId) remote = r;
                      });
        
                      const shouldLog = (sampleCount++ % 4) === 0;
                      if (out && shouldLog) {
                        console.log("[ShareX] SEND video: " + out.frameWidth + "x" + out.frameHeight +
                          " @" + Math.round(out.framesPerSecond || 0) + "fps" +
                          " limitedBy=" + (out.qualityLimitationReason || "n/a") +
                          " codec=" + ((codec && codec.mimeType) || "n/a") +
                          " encoder=" + (out.encoderImplementation || "n/a"));
                      }
                      if (pair && shouldLog) {
                        console.log("[ShareX] SEND path: " + ((local && local.candidateType) || "?") +
                          " -> " + ((remote && remote.candidateType) || "?") +
                          " rtt=" + Math.round((pair.currentRoundTripTime || 0) * 1000) + "ms" +
                          " availableOutgoing=" +
                          Math.round((pair.availableOutgoingBitrate || 0) / 1000) + "kbps");
                      }
                      if (!out) return;
        
                      const now = Date.now();
                      const prev = s.statsPrev[pcId];
                      const bytesSent = out.bytesSent || 0;
                      const framesSent = out.framesSent || 0;
                      s.statsPrev[pcId] = {
                        timestamp: now,
                        bytesSent: bytesSent,
                        framesSent: framesSent
                      };
                      // Publish nothing until there is something to difference against.
                      // The first sample can only report a 0 bitrate, and a controller
                      // that classifies content by bitrate would read that as an idle
                      // screen -- an opening decision made from an artefact of startup.
                      if (!prev || now <= prev.timestamp) return;
                      const elapsedSec = (now - prev.timestamp) / 1000;
                      const currentBitrate = Math.max(0,
                        Math.round((bytesSent - prev.bytesSent) * 8 / elapsedSec));
                      const derivedFps = Math.max(0, (framesSent - prev.framesSent) / elapsedSec);
        
                      // The capture source, not the encoder output. scaleResolutionDownBy
                      // is expressed relative to the track, so turning "encode at 1280
                      // wide" into a scale factor needs the size the track is actually
                      // handing the encoder — and that size changes on its own when the
                      // user resizes a shared window.
                      let sourceWidth = 0, sourceHeight = 0;
                      try {
                        const st = track.getSettings ? track.getSettings() : {};
                        sourceWidth = st.width || 0;
                        sourceHeight = st.height || 0;
                      } catch (_) {}
        
                      // packetsLost is signed in the spec (a late-arriving packet can
                      // walk it backwards), and the Kotlin side reads it as a count.
                      const packetsLost = Math.max(0, (inbound && inbound.packetsLost) || 0);
        
                      s.encoderStats[pcId] = JSON.stringify({
                        timestamp: now,
                        currentBitrate: currentBitrate,
                        targetBitrate: Math.round(out.targetBitrate || 0),
                        frameRate: (typeof out.framesPerSecond === "number" && out.framesPerSecond > 0)
                          ? out.framesPerSecond
                          : derivedFps,
                        framesSent: framesSent,
                        framesEncoded: out.framesEncoded || 0,
                        frameWidth: out.frameWidth || 0,
                        frameHeight: out.frameHeight || 0,
                        packetsSent: out.packetsSent || 0,
                        packetsLost: packetsLost,
                        bytesSent: bytesSent,
                        totalEncodeTime: out.totalEncodeTime || 0,
                        qualityLimitationReason: out.qualityLimitationReason || null,
                        availableOutgoingBitrate:
                          Math.round((pair && pair.availableOutgoingBitrate) || 0),
                        sourceWidth: sourceWidth,
                        sourceHeight: sourceHeight
                      });
                    }).catch(() => {});
                  }, 1000);
                }
                return "";
              } catch (e) {
                return (e && (e.message || e.toString())) || "Failed to add local track";
              }
            }
            ,
        'com.teachmint.sharex.share.shared.bridgePollEncoderStats' : 
            (pcId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.encoderStats) return "";
              const snapshot = s.encoderStats[pcId];
              if (!snapshot) return "";
              delete s.encoderStats[pcId];
              return snapshot;
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeBeginSetEncoderConfiguration' : 
            (pcId, maxBitrate, maxFramerate, scaleResolutionDownBy, preferFramerate, requestId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc || !s) {
                if (s) s.results[requestId] = JSON.stringify({ ok: false, error: "Peer connection not found: " + pcId });
                return;
              }
              (async () => {
                try {
                  const senders = pc.getSenders ? pc.getSenders() : [];
                  const sender = senders.find((x) => x && x.track && x.track.kind === "video");
                  if (!sender || !sender.getParameters) {
                    s.results[requestId] = JSON.stringify({ ok: false, error: "No video sender on " + pcId });
                    return;
                  }
                  // getParameters immediately before setParameters is required, not
                  // stylistic: setParameters rejects a params object that did not come
                  // from the sender's current generation.
                  const params = sender.getParameters();
                  // Do NOT fabricate an encodings array when one is missing.
                  // setParameters validates that encodings.length matches the sender's
                  // current [[SendEncodings]], so replacing an empty [] with [{}] throws
                  // InvalidModificationError — and that rejects the WHOLE call, silently
                  // discarding degradationPreference along with the bitrate and scale we
                  // came here to set. The stream then runs on browser defaults for the
                  // rest of the session with nothing in the logs to say so.
                  if (!params.encodings || params.encodings.length === 0) {
                    s.results[requestId] = JSON.stringify({
                      ok: false,
                      error: "Sender has no RTP encodings yet on " + pcId,
                    });
                    return;
                  }
                  // Follows the content, because neither value is right for both halves
                  // of it. A still screen is read, so its pixels are what matter and
                  // framerate is the cheap thing to lose. A moving screen cannot be read
                  // at all, so frames are what matter and softness costs nothing until it
                  // stops. Measured on a 75 Pro, holding resolution through a scroll gave
                  // 1-8fps with bandwidth to spare -- the encoder was discarding frames
                  // by policy, not for want of bits.
                  const wanted = preferFramerate ? "maintain-framerate" : "maintain-resolution";
                  params.degradationPreference = wanted;
                  params.encodings[0].maxBitrate = Math.round(maxBitrate);
                  params.encodings[0].maxFramerate = maxFramerate;
                  params.encodings[0].scaleResolutionDownBy = scaleResolutionDownBy;
                  await sender.setParameters(params);
                  // The track hint points the same way. On its own it is advisory, but
                  // left at "detail" it pulls against a maintain-framerate preference.
                  try {
                    const hint = preferFramerate ? "motion" : "detail";
                    if (sender.track && sender.track.contentHint !== hint) {
                      sender.track.contentHint = hint;
                    }
                  } catch (_) {}
                  // Read back rather than assume. Chrome accepts degradationPreference
                  // and can still report a different effective value, and this is the
                  // field the whole resolution policy rests on.
                  let effective = "unknown";
                  try { effective = sender.getParameters().degradationPreference || "unset"; } catch (_) {}
                  if (effective !== wanted) {
                    console.warn("[ShareX] degradationPreference did not stick: wanted " +
                      wanted + ", sender reports " + effective);
                  }
                  s.results[requestId] = JSON.stringify({ ok: true });
                } catch (e) {
                  const message = (e && (e.message || e.toString())) || "Failed to set encoder configuration";
                  s.results[requestId] = JSON.stringify({ ok: false, error: message });
                }
              })();
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeStopTrack' : 
            (trackId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.tracks) return;
              const track = s.tracks[trackId];
              if (track && track.stop) {
                try { track.stop(); } catch (_) {}
              }
              const streamId = s.trackToStream ? s.trackToStream[trackId] : null;
              if (streamId && s.streams && s.streams[streamId] && s.streams[streamId].getTracks) {
                try {
                  s.streams[streamId].getTracks().forEach((t) => { try { t.stop(); } catch (_) {} });
                } catch (_) {}
                delete s.streams[streamId];
              }
              if (s.trackToStream) delete s.trackToStream[trackId];
              delete s.tracks[trackId];
              // Let the display sleep again once nothing is being captured. Checked
              // against the remaining tracks rather than assumed, because a share
              // carries an audio track alongside the video and stopping either one
              // reaches this function.
              if (globalThis.__sharexWakeLock) {
                let stillCapturing = false;
                try {
                  for (const id in s.tracks) {
                    const t = s.tracks[id];
                    if (t && t.kind === "video" && t.readyState === "live") { stillCapturing = true; break; }
                  }
                } catch (_) { stillCapturing = false; }
                if (!stillCapturing) globalThis.__sharexWakeLock.release();
              }
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeTakeCaptureEndedExternally' : 
            () => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.captureEndedExternally) return false;
              s.captureEndedExternally = false;
              return true;
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeClosePeerConnection' : 
            (pcId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s) return;
              const pc = s.pcs ? s.pcs[pcId] : null;
              if (pc && pc.close) {
                try { pc.close(); } catch (_) {}
              }
              if (s.statsTimers && s.statsTimers[pcId]) {
                try { clearInterval(s.statsTimers[pcId]); } catch (_) {}
                delete s.statsTimers[pcId];
              }
              if (s.pcs) delete s.pcs[pcId];
              if (s.iceQueues) delete s.iceQueues[pcId];
              if (s.remoteTrackQueues) delete s.remoteTrackQueues[pcId];
              if (s.encoderStats) delete s.encoderStats[pcId];
              if (s.statsPrev) delete s.statsPrev[pcId];
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeCreateDataChannel' : 
            (pcId, label, negotiatedId) => {
              const s = globalThis.__sharexWebRtcBridge;
              const pc = s && s.pcs ? s.pcs[pcId] : null;
              if (!pc) return "";
              if (!s.dataChannels) s.dataChannels = {};
              if (!s.dcMessageQueues) s.dcMessageQueues = {};
              const dcId = "dc-" + (s.nextId++);
              const dc = pc.createDataChannel(label, {
                ordered: true,
                negotiated: true,
                id: negotiatedId
              });
              s.dataChannels[dcId] = dc;
              s.dcMessageQueues[dcId] = [];
              dc.binaryType = "arraybuffer";
              dc.onmessage = (event) => {
                try {
                  const data = event.data;
                  let base64;
                  if (data instanceof ArrayBuffer) {
                    const bytes = new Uint8Array(data);
                    let binary = "";
                    for (let i = 0; i < bytes.byteLength; i++) {
                      binary += String.fromCharCode(bytes[i]);
                    }
                    base64 = btoa(binary);
                  } else {
                    base64 = btoa(data);
                  }
                  s.dcMessageQueues[dcId].push(base64);
                } catch (_) {}
              };
              dc.onopen = () => { console.log("[ShareX] DataChannel " + label + " opened"); };
              dc.onclose = () => { console.log("[ShareX] DataChannel " + label + " closed"); };
              return dcId;
            }
            ,
        'com.teachmint.sharex.share.shared.bridgePollDataChannelMessage' : 
            (dcId) => {
              const s = globalThis.__sharexWebRtcBridge;
              if (!s || !s.dcMessageQueues || !s.dcMessageQueues[dcId]) return "";
              if (s.dcMessageQueues[dcId].length === 0) return "";
              return s.dcMessageQueues[dcId].shift() || "";
            }
            ,
        'com.teachmint.sharex.share.shared.bridgeSendDataChannel' : 
            (dcId, base64Data) => {
              const s = globalThis.__sharexWebRtcBridge;
              const dc = s && s.dataChannels ? s.dataChannels[dcId] : null;
              if (!dc || dc.readyState !== "open") return;
              try {
                const binary = atob(base64Data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                  bytes[i] = binary.charCodeAt(i);
                }
                dc.send(bytes.buffer);
              } catch (e) {
                console.warn("[ShareX] DataChannel send failed:", e);
              }
            }
            ,
        'com.teachmint.sharex.share.client.web.browserOsToken' : 
            () => {
              const nav = typeof navigator !== "undefined" ? navigator : null;
              if (!nav) return "unknown";
              const platform = (nav.userAgentData && nav.userAgentData.platform) || "";
              const ua = nav.userAgent || "";
              const hay = (platform + " " + ua).toLowerCase();
              // iPadOS 13+ reports itself as a Mac, so the touch-point count is the only
              // way left to tell an iPad from a MacBook.
              if (/iphone|ipod|ipad/.test(hay)) return "ios";
              if (/macintosh|mac os x/.test(hay)) {
                return nav.maxTouchPoints > 1 ? "ios" : "mac";
              }
              if (/android/.test(hay)) return "android";
              if (/windows/.test(hay)) return "windows";
              if (/cros|linux|x11/.test(hay)) return "linux";
              return "unknown";
            }
            ,
        'com.teachmint.sharex.share.client.web.browserOsDisplayName' : 
            () => {
              const nav = typeof navigator !== "undefined" ? navigator : null;
              if (!nav) return null;
              const platform = (nav.userAgentData && nav.userAgentData.platform) || "";
              const ua = nav.userAgent || "";
              const hay = (platform + " " + ua).toLowerCase();
              if (/iphone|ipod/.test(hay)) return "iPhone";
              if (/ipad/.test(hay)) return "iPad";
              if (/macintosh|mac os x/.test(hay)) {
                return nav.maxTouchPoints > 1 ? "iPad" : "Mac";
              }
              if (/android/.test(hay)) return "Android";
              if (/windows/.test(hay)) return "Windows";
              if (/cros/.test(hay)) return "ChromeOS";
              if (/linux|x11/.test(hay)) return "Linux";
              return null;
            }
            ,
        'com.teachmint.sharex.share.client.web.browserEngineName' : 
            () => {
              const nav = typeof navigator !== "undefined" ? navigator : null;
              if (!nav) return null;
              const ua = nav.userAgent || "";
              // Order matters: every Chromium browser still carries "Chrome" and "Safari"
              // in its UA, so the more specific brands have to be tested first.
              if (/Edg\//.test(ua)) return "Edge";
              if (/OPR\/|Opera/.test(ua)) return "Opera";
              if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
              if (/Firefox\/|FxiOS/.test(ua)) return "Firefox";
              if (/CriOS/.test(ua)) return "Chrome";
              if (/Chrome\//.test(ua)) return "Chrome";
              if (/Safari\//.test(ua)) return "Safari";
              return null;
            }
            ,
        'com.teachmint.sharex.share.client.web.browserIsMobileOrTablet' : 
            () => {
              const nav = typeof navigator !== "undefined" ? navigator : null;
              if (!nav) return false;
              if (nav.userAgentData && typeof nav.userAgentData.mobile === "boolean" &&
                  nav.userAgentData.mobile) {
                return true;
              }
              const ua = nav.userAgent || "";
              if (/iPhone|iPod|Android.*Mobile|Windows Phone/.test(ua)) return true;
              // Tablets: iPad (including the iPadOS-as-Mac disguise), and Android without
              // the "Mobile" token.
              if (/iPad/.test(ua)) return true;
              if (/Macintosh|Mac OS X/.test(ua) && nav.maxTouchPoints > 1) return true;
              if (/Android/.test(ua) && !/Mobile/.test(ua)) return true;
              return false;
            }
            ,
        'com.teachmint.sharex.share.client.web.browserOpenInNewTab' : 
            (url) => {
              const root = typeof globalThis !== "undefined" ? globalThis : null;
              if (!root) return;
              // noopener so the opened tab cannot reach back into this one.
              const opened = root.open ? root.open(url, "_blank", "noopener,noreferrer") : null;
              if (!opened && root.location) {
                root.location.href = url;
              }
            }
            ,
        'com.teachmint.sharex.share.client.web.jsReadInstallerUrl' : 
            (manifestUrl) =>
              fetch(manifestUrl, { cache: "no-store" })
                .then((response) => (response.ok ? response.json() : null))
                // Only https, and only from the manifest: this URL is handed straight
                // to the browser, so nothing else is worth trusting with it.
                .then((manifest) => {
                  const url = manifest && manifest.url;
                  return typeof url === "string" && url.startsWith("https://") ? url : null;
                })
                .catch(() => null)
            ,
        'com.teachmint.sharex.share.client.web.browserDownloadFile' : 
            (url) => {
              const doc = typeof document !== "undefined" ? document : null;
              if (!doc) return;
              // An anchor click rather than window.open: the download starts after an
              // await, by which point a popup blocker no longer credits the tap that
              // asked for it. Cross-origin downloads ignore the download attribute,
              // but it costs nothing and names the file if this is ever same-origin.
              const link = doc.createElement("a");
              link.href = url;
              link.rel = "noopener";
              link.download = "";
              doc.body.appendChild(link);
              link.click();
              link.remove();
            }
        
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './TeachmintShareX-composeApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./TeachmintShareX-composeApp.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
